import React from 'react';
import { Box, keyframes } from '@mui/material';

const scan = keyframes`
  from {
    background-position: 0 0;
  }
  to {
    background-position: 40px 40px;
  }
`;

const GridLayer: React.FC = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.15,
        pointerEvents: 'none',
        backgroundImage: `radial-gradient(circle, #00f296 1px, transparent 1px)`,
        backgroundSize: '40px 40px',
        animation: `${scan} 10s linear infinite`,
        zIndex: 1,
      }}
    />
  );
};

export default GridLayer;
